export enum TableDefault {
  TABLE_PAGE_SIZE = 5
}
